import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { nanoid } from 'nanoid'
import { useApolloClient, gql, useMutation, useQuery } from "@apollo/client";

// import * as _routerDom from 'react-router-dom';
import * as _apolloClient from "@apollo/client";
import * as _React from 'react';

const apolloClient = {
    ..._apolloClient,
    // useApolloClient: _apolloClient.useApolloClient
}

const React = Object.keys(_React).filter((a) => a.indexOf('use') > -1).map((x) => ({key: x, value: _React[x]})).reduce((prev, curr) => ({...prev, [curr.key]:curr.value}), {}) 
// {
//     useEffect: _React.useEffect,
//     useMem
//     useState: _React.useState
// }

export const InnerComponent = (props: any) => {
    const ref = useRef(null);


    let {options = {}, error = null} = (() => {
        if (typeof (props.options) == 'string') {
            try {
                const jsonOptions = JSON.parse(props.options)
                return jsonOptions
            } catch (err) {
                const keys = [...new Set([...Object.keys(apolloClient), ...Object.keys(React)])]
                const values = [...Object.keys(apolloClient).map((key) => apolloClient[key]), ...Object.keys(React).map((key) => React[key])];

                try{
                    const f = new Function(...keys, props.options + '\n return options;\n');

                    const options = f(...values)();
                    return {options};
                }catch(err){
                    return {error: err.message}
                }
            }
        } else {
            if (props.options instanceof Function) {
                return {options: props.options?.()};
            } else {
                return {options: props.options};
            }
        }
    })();

    const [id] = useState(nanoid());


    // useEffect(() => {
    //     (async () => {
    //         await Promise.all((props.elements || []).map(async (element) => {
    //             try {
    //                 return await importModule?.(element.name)
    //             } catch (err) {
    //                 setError(`Failed to load ${element.name}`)
    //             }
    //         })).catch((err) => {
    //             setError(err.message)
    //         })
    //         setReady(true);
    //     })();
    // }, [props.elements, elements])

    useEffect(() => {

        const domElementGetter = () => {
            return ref.current;
        }

        props.mount?.({
            name: id,
            ...options,
            domElementGetter
        }, {
            active: false
        });

        return () => {
            setTimeout(() => {
                props.unmount?.({ name: id, ...options });
            })
        }
    }, [JSON.stringify(options), id]);

    return (
        <div style={{
            flex: 1,
            display: 'flex'
        }} ref={ref}>
            {!props.mount &&
                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                    <CircularProgress />
                    <Typography>Loading...</Typography>
                </Box>
            }
            {error ? <Typography color="error">{error}</Typography> : null}
        </div>
    )
}
